import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,FormGroup,ControlLabel,FormControl,Table} from "react-bootstrap";
import { API } from "aws-amplify";
import Moment from 'react-moment';
import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import LoaderButton from "../components/LoaderButton";
import ReactMarkdown from 'react-markdown/with-html'

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}



export default class AdminUserRef extends Component {
    constructor(props) {
      super(props);
      this.state = {
          myaltioms:[],
          myaltioms_fetching:true,
          markdown:"",
          newUser:false,
          responce:"",
          isLoading:true,
          isSuper:false,
          data:{}
      };
    }

    async componentWillMount() {
      const data = await this.getInfo();
      if (data.data.super==true){
        let resp=await this.getAdmin({admin:true,type:"user",cmd:"getuser",user:this.props.match.params.id})
        console.log(resp)
        resp=this.formatPermissionData(resp)
        this.setState({data:resp})
        this.setState({isSuper:true})
        this.setState({isLoading:false})
      }
      this.setState({isLoading:false})



    }


    getBranchname(branch_list,branch){
      for(let i=0; i<branch_list.length; i++){
        if(branch_list[i].userId==branch){
          return branch_list[i].name
        }
      }
      return branch

    }

    formatPermissionData(data){
      console.log("Format permission")
      let branch_formatted=[]
      let branch={}
      try{
      branch=JSON.parse(data.permissions.branch)
    }catch(err){}
      console.log(branch)
      let branch_keys=Object.keys(branch)
      for (let i in branch_keys){
        console.log(i)
        console.log(this.getBranchname(data.branchlist,branch_keys[i]))
        branch_formatted.push({id:branch_keys[i], name:this.getBranchname(data.branchlist,branch_keys[i]),permission:branch[branch_keys[i]]})
      }
      console.log(branch_formatted)
      //Sort the list alphabeticly
      data.permission_formatted=branch_formatted


      return data
    }


    getAdmin(data){
      let getdata = {
        'queryStringParameters': data
      }
      return API.get("AltiomData", "/welcome",getdata);
    }
    responceChanged=(e)=>{
      console.log(e.target.value)
      this.setState({responce:e.target.value})


    }


    getAccess(note){
      let data = {
        'queryStringParameters': {
            'note': note,
            'newUser': true
        }
      }
      return API.get("AltiomData", "/welcome",data);
    }

    getInfo() {
      return API.get("AltiomData", "/welcome");
    }

     buttonPress=async cmd=>{
       let resp=await this.getAdmin({admin:true,type:"user",cmd:cmd,user:this.props.match.params.id})
       console.log(resp)
       this.setState({data:resp})
       this.setState({isSuper:true})
       console.log(cmd)
    }
    render() {
      return (
          <div className="Home">
          <Jumbotron>
            {this.state.isSuper==true ? (<div>
            <h2><a href="/admin">Admin</a> ><a href="/admin/users">Users</a></h2>
            <h3>User Info</h3>


            {"Enabled" in this.state.data ? (<div>
            <b>Id</b>:<span>{this.state.data.Username}</span><br/>
            <b>enabled</b>:<span>{this.state.data.Enabled.toString()}</span><br/>
            <b>status</b>:<span>{this.state.data.UserStatus}</span><br/>
            <b>created</b>:<span>{this.state.data.UserCreateDate}</span><br/>




            {this.state.data.UserAttributes.map((d,i)=><div><b>{d.Name}</b>:<span>{d.Value}</span></div>)}

            <br/>
            <h4>Activity</h4>
            <b>Last Seen:</b><span>{this.state.data.info.last_seen}</span><br/>
            <b>Browser:</b><span>{this.state.data.info.data}</span><br/>
            <b>Country:</b><span>{this.state.data.info.country}</span><br/>


            <br/>
            <h4>Permissions</h4>
            <i> Cognito Mapping  {this.state.data.info.cogId} </i><br/>
                <Table striped bordered condensed hover>
                <thead>
            <tr><th>Branch Name</th><th>Permissions</th></tr>
            </thead>
            <tbody>
              {this.state.data.permission_formatted.map((d,i)=><tr><td>{d.name}</td><td>{d.permission}</td></tr>)}
              </tbody>
            </Table>


            <hr/>

            <Button onClick={()=>this.buttonPress("admin_enable_user")}>Enable</Button><span>&nbsp;Allow user to login</span><br/>
            <Button onClick={()=>this.buttonPress("admin_disable_user")}>Disable</Button><span>&nbsp;Prevent user from login</span><br/>
            {/*}<Button onClick={()=>this.buttonPress("admin_user_global_sign_out")}>Revoke all sessions (Logout)</Button><span>&nbsp;Sign user out, revokes current session. will be forced to login after credentials expire. (1h from last use)</span><br/>*/}
            <Button onClick={()=>this.buttonPress("admin_confirm_sign_up")}>Confirm User</Button><span>&nbsp;Skip confirmation code</span><br/>
            <Button onClick={()=>this.buttonPress("admin_delete_user")} disabled bsStyle="danger">Delete User</Button><br/>
            </div>):("User Not Found")}

            </div>):(<div>
{this.state.isLoading==true ? (<p>Loading</p>):(<p>No Data for you</p>)}
              </div>

            )}
            </Jumbotron>
          </div>
        );
    }
}

//{this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}



// WEBPACK FOOTER //
// ./src/containers/AdminUserRef.js